import { useContext,useReducer,createContext,useState } from "react";
import { App_store__token, ModalpropsCustom, NecesidadTypes } from "../utils/constants";



export const FilterNecesidadesInit = {
  rows_per_page: 20,
  page_number: 0,
  filter_search: "",
  producto:null,
  fecha:null,
  necesidad_cubierta:-1,
  tipo_necesidad:NecesidadTypes.PROPIA
}

export const AppContext = createContext(null);
let localeData = localStorage.getItem(App_store__token);
const InitialState = localeData? {...JSON.parse(localeData),isLoadingApp:false}:{
  profile:{},
  filterNecesidades:FilterNecesidadesInit,
  isLoadingApp:false,
  modalProps:ModalpropsCustom
};


export const ActionTypes = {
setProfileUsers:"setProfileUsers",
setLoadingPage:"setLoadingPage",
setModalInfo:"setModalInfo",
setFilterNecesidades:"setFilterNecesidades"
};

export const ResolverActions  = (state=InitialState,payload={type:"",data:undefined})=>{
    let newState = {...state};
    if( payload.type === ActionTypes.setProfileUsers ){
      newState.profile = payload.data;
    }
    if( payload.type === ActionTypes.setLoadingPage ){
      newState.isLoadingApp = payload.data;
    
    }
    if( payload.type === ActionTypes.setModalInfo ){
      newState.modalProps = payload.data;
    }
    if( payload.type === ActionTypes.setFilterNecesidades ){
      newState.filterNecesidades = payload.data;
    }
    localStorage.setItem(App_store__token,JSON.stringify( newState )  );

    return newState;
}


export const AppStoreProvider = ({children})=>{

    const [state,dispatch] = useReducer(ResolverActions,InitialState);

   return (
    <AppContext.Provider
    value={{
     store:state,
     dispatch
    }}
    >
   {children}
    </AppContext.Provider>
   )


}